export default "__VITE_ASSET__CTq9u1Qa__"